import React, { ReactElement, ReactNode } from 'react';
import {
  createBrowserRouter,
  createRoutesFromElements,
  NonIndexRouteObject,
  Route,
  RouterProvider,
} from 'react-router';

import { ChatInputProps } from '~/components/chat';
import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { ProtectedView } from '~/components/protected-view/ProtectedView';
import { Root } from '~/Root';
import { ServerError } from '~/views/error';
import { NotFound } from '~/views/error/not-found/NotFound';

import { appPaths } from './app-paths';
import { authRoutes, routes } from './AppRoutes';

export type AppRoute = Omit<NonIndexRouteObject, 'element'> & {
  element: ReactElement<{
    renderChatInput: (props?: ChatInputProps) => ReactNode;
  }>;
};

export const Routes = () => {
  const appRoutes = [...routes, ...authRoutes];

  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route
        path="/"
        element={
          <ErrorBoundaryWrapper fallback={<ServerError />}>
            <Root />
          </ErrorBoundaryWrapper>
        }
      >
        {appRoutes.map(config => (
          <Route
            path={config.path}
            element={<ProtectedView config={config} />}
            key={config.path}
          />
        ))}
        <Route path={appPaths.notFound} element={<NotFound />} />
      </Route>
    )
  );

  return <RouterProvider router={router} />;
};
